export default __webpack_public_path__ + "../img/5df301db1887c8d8476b48a820e97645.png";